<template>
  <LoadingChartContainer
    :chart-options="chartOptions"
    :loading="loading"
    :elevation="elevation"
  >
    <template #header>
      <slot name="header" />
    </template>
    <template #loading-component>
      <div class="loading-container">
        <span class="loading-text">{{ loadingText }}</span>
        <v-progress-circular
          indeterminate
          color="var(--color-primary)"
          size="32"
        />
      </div>
    </template>
  </LoadingChartContainer>
</template>

<script>
import LoadingChartContainer from "./LoadingChartContainer.vue";

export default {
  name: "SimpleLoadingChartContainer",
  components: {
    LoadingChartContainer,
  },
  props: {
    loadingText: {
      type: String,
      required: true,
      default: "Loading...",
    },
    chartOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    elevation: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  gap: 20px;
}

.loading-text {
  color: var(--color-text);
}
</style>
